"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Houses = require("./Houses");
Object.keys(_Houses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Houses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Houses[key];
    }
  });
});